import { array, number, object, string } from "yup";
import {
  PlanFeatureResource,
  planFeatureResourceSchema,
} from "./PlanFeatureResource";
import { PriceResource, priceResourceSchema } from "./PriceResource";

export interface PlanVariantResource {
  id: number;
  name: string;
  features: PlanFeatureResource[];
  prices: PriceResource[];
}

export const planVariantResourceSchema = object({
  id: number().required(),
  name: string().required(),
  features: array().of(planFeatureResourceSchema).required(),
  prices: array().of(priceResourceSchema).required(),
});
